// Client-safe env: NODE_ENV + NEXT_PUBLIC_* only. Importable from BOTH client
// and server modules — holds NO secrets (those live in the server-only `./env`
// module). Accesses stay literal (`process.env.NEXT_PUBLIC_*`) so Next.js can
// inline them into the browser bundle.
//
// NO zod here, on purpose. `import { z } from "zod"` pulls the entire ~108 KB
// zod runtime into the browser bundle — and this module sits on the storefront
// critical path (imported by the layout's <WebVitalsReporter> and the
// experience-detail view), so that weight landed on every public page just to
// validate two trivial values. zod was the single largest chunk of unused JS
// Lighthouse flagged on mobile (~530–1040 ms of estimated LCP savings). A
// hand-rolled check keeps the public bundle zod-free with identical behaviour:
// NODE_ENV falls back to "development", the NEXT_PUBLIC_* values are optional strings.
const VALID_NODE_ENV = ["development", "production", "test"] as const;
type NodeEnv = (typeof VALID_NODE_ENV)[number];

const rawNodeEnv = process.env.NODE_ENV;
const NODE_ENV: NodeEnv = (VALID_NODE_ENV as readonly string[]).includes(
  rawNodeEnv ?? "",
)
  ? (rawNodeEnv as NodeEnv)
  : "development";

export const envClient = {
  NODE_ENV,
  // Paylexer resource publishable key (pk_…). Browser-safe; per-agency value
  // also arrives with the booking response. When unset, the gateway selector
  // stays dormant and checkout relies on synchronous settle.
  NEXT_PUBLIC_PAYLEXER_PUBLISHABLE_KEY:
    process.env.NEXT_PUBLIC_PAYLEXER_PUBLISHABLE_KEY,
  // Paylexer API base the browser SDK talks to directly. Unset → SDK default.
  NEXT_PUBLIC_PAYLEXER_API_URL: process.env.NEXT_PUBLIC_PAYLEXER_API_URL,
  NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
} as const;
